import endpoints from 'config/endpoints';
import {getAccountColor} from 'modules/store/accounts';

import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import {FALSE_VALUE, TRUE_VALUE, TIMEOUT_STORE, DEFAULT_ARRAY, IS_EMPTY, TIMESTAMP_MULTIPLY} from 'util/constants';

const
    mapFields = {
        contact_method: 'contactMethod',
        service_code:   'serviceCode',
        category_code:  'categoryCode'
    },
    parseParameters = parameters => Object.keys(parameters).reduce((ret, key) => ({
        ...ret,
        startDate: parameters.startDate && Math.floor(parameters.startDate / TIMESTAMP_MULTIPLY),
        endDate:   parameters.endDate && Math.floor(parameters.endDate / TIMESTAMP_MULTIPLY),
        [key]:     key === 'resolved' ? parameters[key] ? TRUE_VALUE : FALSE_VALUE : parameters[key]
    }), {}),
    createFetchParams = (filters, page, selectedAccount,ticket) => ({
        ...filters,
        page,
        account:  selectedAccount,
        ticketId: ticket
    }),
    transformEntitiesFn = ticket => ({
        id:               ticket.case_id,
        display:          ticket.display_id,
        created:          ticket.created * TIMESTAMP_MULTIPLY,
        subject:          ticket.subject,
        attachmentsCount: ticket.attachments ? ticket.attachments.length : IS_EMPTY,
        attachments:      ticket.attachments ? ticket.attachments.map(item => ({
            id:   item.id,
            name: item.file_name
        })) : DEFAULT_ARRAY,
        accountId:    ticket.account.id,
        accountAwsId: ticket.account.account_id,
        accountName:  ticket.account.name,
        accountColor: getAccountColor(ticket.account.name),
        severity:     ticket.severity.code,
        category:     ticket.category.name,
        service:      ticket.service.name,
        status:       ticket.status,
        description:  ticket.body,
        cc:           ticket.cc || DEFAULT_ARRAY
    }),
    transformEntitiesToSaveFn = ticket => ({
        cc:          ticket.cc,
        subject:     ticket.subject,
        description: ticket.description,
        attachments: ticket.attachments.map(item => ({
            file_name: item.name,
            hash:      item.hash
        })),
        account_id:    ticket.accountId,
        service_code:  ticket.type.serviceCode,
        category_code: ticket.type.categoryCode
    });
const _callbackClose = (state, action) => ({
    ...state,
    isClosing:     true,
    didInvalidate: false,
    error:         null,
    lastAction:    ''
});
const _callbackCloseSuccess = (state, action) => {

    const
        newEntity = action.entity,
        newTicket = transformEntitiesFn(newEntity),
        newState = {
            ...state,
            isClosing:  false,
            lastAction: 'close'
        };

    Object.keys(state.cache.entities).forEach(key => {
        const
            entities = state.cache.entities[key].data.slice(),
            ticketIndex = entities.findIndex(_ticket => _ticket.id === newTicket.id);

        if (~ticketIndex) {
            const ticket = entities[ticketIndex];

            if (newTicket.status !== ticket.status) {
                ticket.status = newTicket.status;

                newState.cache = {
                    ...newState.cache,
                    entities: {
                        ...state.cache.entities,
                        [key]: {
                            ...state.cache.entities[key],
                            data: entities
                        }
                    }
                };
            }
        }
    });

    const entity = state.cache.entity[newTicket.id];

    if (entity && entity.data) {
        const ticket = {...entity.data};

        if (newTicket.status !== ticket.status) {
            ticket.status = newTicket.status;

            newState.cache = {
                ...newState.cache,
                entity: {
                    ...state.cache.entity,
                    [ticket.id]: {
                        ...state.cache.entity[ticket.id],
                        data: ticket
                    }
                }
            };
        }
    }

    return newState;
};

const exports = storeModuleFactory({
    name:             'awsSupport',
    endpoint:         endpoints.awsSupport.endpoint,
    instanceEndpoint: endpoints.awsSupport.instanceEndpoint,
    timeout:          TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
    parseParameters,
    transformEntitiesFn,
    transformEntitiesToSaveFn,
    filterParamsMap:  {
        startDate: 'start_date',
        endDate:   'end_date'
    },
    extraActions: [{
        method:  'update',
        action:  'close',
        url:     endpoints.awsSupport.close,
        start:   _callbackClose,
        success: _callbackCloseSuccess
    }]
});

exports.transformEntitiesFn = transformEntitiesFn;
exports.transformEntitiesToSaveFn = transformEntitiesToSaveFn;
exports.createFetchParams = createFetchParams;
exports.mapFields = mapFields;

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/awsSupport.js